import { Collapse, IconButton, TableCell, TableRow } from "@material-ui/core"
import React, { useState } from "react"
import { FunctionComponent } from "react"
import { Link } from "react-router-dom"
import { TransactionModel } from "./TransactionsTable"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import { TransactionCard } from "./TransactionCard"
import _ from "lodash"
import { TimeStamp } from "../../components/TimeStamp"
import { TransactionGroupLink } from "./TransactionGroupLink"

export interface TransactionGroupProps {
    transactions: TransactionModel[]
}

export interface GroupData {
    id: string
    user: string | undefined
    type: string
    createdAt: string | undefined
}
export const TransactionGroup: FunctionComponent<TransactionGroupProps> = ({ transactions }) => {
    const [open, setOpen] = useState<boolean>(false)
    const sortedTransactions = _.sortBy(transactions, "createdAt")

    const groupData: GroupData = {
        id: sortedTransactions[0].referenceId,
        user: sortedTransactions[0].user?.email,
        type: sortedTransactions[0].mode,
        createdAt: sortedTransactions[0].createdAt
    }

    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton
                        size="small"
                        onClick={() => setOpen(!open)}
                        data-testid="openButton"
                        id={"open" + groupData.id}
                        className="openButton"
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell id={"referenceId" + groupData.id} data-testid="referenceId">
                    <TransactionGroupLink transactions={transactions} />
                </TableCell>
                <TableCell id={"user" + groupData.id} data-testid="user">
                    {groupData.user}
                </TableCell>
                <TableCell id={"type" + groupData.id} data-testid="type">
                    {groupData.type}
                </TableCell>
                <TableCell id={"createdAt" + groupData.id} data-testid="createdAt">
                    <TimeStamp value={groupData.createdAt} />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    id={"group" + groupData.id}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={10}
                    align="center"
                >
                    <Collapse
                        in={open}
                        timeout="auto"
                        unmountOnExit
                        style={{
                            paddingTop: 20,
                            paddingBottom: 20,
                            paddingLeft: 0,
                            paddingRight: 0
                        }}
                    >
                        {open &&
                            transactions.map(transaction => (
                                <TransactionCard key={transaction.id} transaction={transaction} />
                            ))}
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}
